import Typography from '@material-ui/core/Typography';
import PropTypes from 'prop-types';

import { getTextAnnotationTypeLabel, TEXT_ANNOTATION_TYPE } from 'src/data/annotation';

import { InsightBox } from '../InsightBox';

import { Loader } from './components/Loader';
import { useStyles } from './useStyles';

export const ScoreAdditionalFactors = ({ campaignKeywords, headlineType, loading }) => {
  const styles = useStyles();

  const haveAdditionalFactors = Boolean(headlineType) || campaignKeywords?.length > 0;
  if (!haveAdditionalFactors) {
    return null;
  }

  return (
    <InsightBox className={styles.root}>
      <div className={styles.header}>
        <Typography className={styles.title}>Additional factors that impact your score</Typography>
      </div>

      {loading ? (
        <Loader />
      ) : (
        <>
          <div className={styles.infoContainer}>
            {headlineType && (
              <div className={styles.infoItem}>
                <Typography className={styles.infoTitle}>Headline type</Typography>
                <Typography className={styles.infoContent}>{headlineType}</Typography>
              </div>
            )}

            {campaignKeywords?.length > 0 && (
              <div className={styles.infoItem}>
                <Typography className={styles.infoTitle}>
                  {getTextAnnotationTypeLabel(TEXT_ANNOTATION_TYPE.campaignKeywords)}
                </Typography>

                <div className={styles.keywordsContainer}>
                  {campaignKeywords.map((keyword) => (
                    <Typography
                      key={keyword}
                      className={styles.infoContent}
                    >
                      {keyword}
                    </Typography>
                  ))}
                </div>
              </div>
            )}
          </div>
        </>
      )}
    </InsightBox>
  );
};

ScoreAdditionalFactors.propTypes = {
  loading: PropTypes.bool,
  campaignKeywords: PropTypes.arrayOf(PropTypes.string),
  headlineType: PropTypes.string,
};

ScoreAdditionalFactors.defaultProps = {
  loading: false,
  campaignKeywords: null,
  headlineType: '',
};
